import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgResizeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 11,
	viewBox: "0 0 21 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: 5,
			width: 21,
			height: 1,
			rx: .5,
			fill: "#A8A8A8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 0L8 3H13L10.5 0Z",
			fill: "#CDCDCD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5 11L8 8H13L10.5 11Z",
			fill: "#CDCDCD"
		})
	]
});
export default SvgResizeIcon;
